import { render, staticRenderFns } from "./ModalPoints.vue?vue&type=template&id=b3fd6162"
import script from "./ModalPoints.vue?vue&type=script&lang=ts"
export * from "./ModalPoints.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports